import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import CancelButton from '../cancelButton';
import { Box } from '@mui/material';
import ButtonSave from '../../buttonSave';

export default function Confirmation({ children, handleClose, accept, textButton, ...props }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));


    return (
        <div>
            <Dialog
                fullScreen={fullScreen}
                onClose={handleClose}
                {...props}
                aria-labelledby="responsive-dialog-title"
            >
                <Box sx={{background:'#f1f6ff', padding: "1rem"}}>

                    <DialogContentText sx={{fontWeight: "bold"}}>
                        {children}
                    </DialogContentText>
                    <DialogActions sx={{ width: "100%", justifyContent: 'center' }}>
                        <CancelButton onClick={handleClose}></CancelButton>
                        <ButtonSave onClick={accept} autoFocus>
                            {!!textButton ? textButton : "Sim" }
                        </ButtonSave>
                    </DialogActions>
                </Box>
            </Dialog>
        </div>
    );
}